module.exports = "<ion-card color=\"medium\">\n  <p>\n    {{messageKey | translate}}\n  </p>\n</ion-card>"